import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { DownloadSimple, X } from "@phosphor-icons/react";

const DISMISS_KEY = "gf347_install_dismissed";

export default function InstallPWA() {
    const [prompt, setPrompt] = useState(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        function onBeforeInstall(e) {
            e.preventDefault();
            setPrompt(e);
            // Solo mostrar si no se ha descartado recientemente
            const dismissed = localStorage.getItem(DISMISS_KEY);
            if (!dismissed || Date.now() - Number(dismissed) > 7 * 24 * 60 * 60 * 1000) {
                setTimeout(() => setVisible(true), 4000);
            }
        }
        function onInstalled() {
            setVisible(false);
            setPrompt(null);
        }
        window.addEventListener("beforeinstallprompt", onBeforeInstall);
        window.addEventListener("appinstalled", onInstalled);
        return () => {
            window.removeEventListener("beforeinstallprompt", onBeforeInstall);
            window.removeEventListener("appinstalled", onInstalled);
        };
    }, []);

    async function install() {
        if (!prompt) return;
        prompt.prompt();
        await prompt.userChoice;
        setPrompt(null);
        setVisible(false);
    }

    function dismiss() {
        localStorage.setItem(DISMISS_KEY, String(Date.now()));
        setVisible(false);
    }

    return (
        <AnimatePresence>
            {visible && prompt && (
                <motion.div
                    initial={{ y: 100, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 100, opacity: 0 }}
                    transition={{ duration: 0.4, ease: [0.25, 0.1, 0.25, 1] }}
                    className="fixed left-6 right-6 md:left-auto md:right-6 md:max-w-sm z-[140] bg-white border border-[var(--gf-border)] shadow-2xl"
                    style={{ bottom: "160px", boxShadow: "0 20px 60px rgba(11,25,44,0.25)" }}
                    data-testid="install-pwa-banner"
                >
                    <div className="p-5">
                        <div className="flex items-start justify-between gap-3 mb-3">
                            <div className="flex items-center gap-3">
                                <img src="/icon-192.png" alt="" className="w-10 h-10 object-contain" />
                                <div>
                                    <div className="micro-label">— Instalar app</div>
                                    <h3 className="serif text-lg leading-tight">Gestión Fiscal 347</h3>
                                </div>
                            </div>
                            <button onClick={dismiss} className="text-[var(--gf-text-muted)] hover:text-[var(--gf-navy)]" data-testid="install-dismiss" aria-label="Cerrar">
                                <X size={18} />
                            </button>
                        </div>
                        <p className="text-xs text-[var(--gf-text-secondary)] mb-4 leading-relaxed">
                            Instala la app en tu dispositivo para acceder al instante sin abrir el navegador.
                        </p>
                        <button onClick={install} className="btn-gold w-full justify-center text-sm" data-testid="install-accept">
                            <DownloadSimple size={16} weight="bold" /> Instalar ahora
                        </button>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
